import React, { Component, Fragment } from 'react';
import { UserLink } from '../../Links/Links';
import { Desktop, Mobile } from '../../MediaQuery';
import { signup } from '../../../helpers/routes';
import { MobileMarginButtonWrapper } from './style';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

class AnonLinks extends Component {
  constructor(props) {
    super(props);
    const { buildUrlWithCountry } = this.props;
    this.state = {
      loginUrl: buildUrlWithCountry(`${signup}?tab=login`),
      registerUrl: buildUrlWithCountry(`${signup}?tab=register`)
    };
  }

  componentDidMount() {
    const { buildUrlWithCountry } = this.props;
    this.setState({
      loginUrl: buildUrlWithCountry(
        `${signup}?tab=login&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`
      ),
      registerUrl: buildUrlWithCountry(
        `${signup}?tab=register&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`
      )
    });
  }

  render() {
    const { loginUrl, registerUrl } = this.state;
    return (
      <Fragment>
        <MobileMarginButtonWrapper margin="0 20px 0 0">
          <UserLink href={loginUrl} data-cy="header-signin-link" padding="10px 15px 0">
            Sign in <Desktop>/ Sign up</Desktop>
          </UserLink>
        </MobileMarginButtonWrapper>

        <Mobile>
          <MobileMarginButtonWrapper margin="0 20px 0 0">
            <UserLink href={registerUrl} data-cy="header-register-link" padding="0 15px">
              Sign up
            </UserLink>
          </MobileMarginButtonWrapper>
        </Mobile>
      </Fragment>
    );
  }
}

AnonLinks.propTypes = {};

export default withCountryCode(AnonLinks);
